<template>
  <div class="container-fluid">
    <div class="loading" v-if="loading">Loading&hellip;</div>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Cupones de tarjetas</h1>
          <p class="view-header__subtitle">Cupones de tarjeta de crédito en cartera y sus movimientos.</p>
        </div>
        <div class="view-header__actions">
          <button type="button" class="btn view-header__btn view-header__btn--primary" @click="openNewcoupon">
            <i class="bi bi-plus-lg"></i>
            Nuevo cupón
          </button>
        </div>
      </div>
    </div>

    <!-- BALANCE -->
    <div class="stats-card">
      <div class="stats-card__value">{{ formatoDinamicoMoneda(totalAmount) }}</div>
      <div class="stats-card__label">Monto total de cupones en cartera</div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input v-model="doSearch" type="search" class="form-control" placeholder="Buscar cupón...">
          </div>
          <div class="filters-panel__field">
            <q-select v-model="branchoffice_id" :options="branchofficeOptions" placeholder="Todas las sucursales" />
          </div>
          <div class="filters-panel__field filters-panel__field--inline">
            <label class="control-label">Fecha de cobro:</label>
            <Daterange
              :opendir="'left'"
              :filtered="true"
              :initial-start="startDate"
              :initial-end="endDate"
              @datepicked="dateCreated"
            />
          </div>
          <div class="filters-panel__actions">
            <button type="button" class="filters-panel__btn" @click="exportCSV">
              <i class="bi bi-filetype-csv"></i>
              Exportar CSV
            </button>
            <button type="button" class="filters-panel__btn" @click="exportPDF">
              <i class="bi bi-filetype-pdf"></i>
              Exportar PDF
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
        @edit="changeCouponId"
        @cash="showcashCouponModal"
        @delete="deleteCoupon"
      />
    </div>

    <!-- MODAL DEPÓSITO -->
    <DepositModal
      v-if="showModal"
      :funds="funds"
      @fundSelected="depositForm"
      @close="showModal = false"
    />

    <!-- MODAL NUEVO / EDITAR CUPÓN -->
    <transition name="modal">
      <div v-if="showNewCouponModal" class="modal-mask-product">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="form-card__header">
              <h6 class="form-card__title">
                <i class="bi bi-credit-card"></i>
                {{ couponIdParent ? 'Editar cupón' : 'Nuevo cupón de tarjeta' }}
              </h6>
              <button type="button" class="form-card__btn" @click="closeNewCoupon">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
            <div class="modal-body">
              <NuevoCuponTarjeta
                :couponId="couponIdParent"
                @reset-id="couponIdParent = null"
                @confirmsave="onCouponSaved"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import NuevoCuponTarjeta from "./../sub-components/Nuevo-cupon-tarjeta.vue";
import formatMoneyMixin from "../../mixins/formatMoneyMixin";
import DepositModal from "../sub-components/depositModal.vue";
import formatDateMixin from "../../mixins/formatDateMixin";
import Daterange from "../global/Daterange-component.vue";
import QSelect from '@/components/shared/QSelect.vue';

export default {
  components: {
    VdtnetTable,
    NuevoCuponTarjeta,
    DepositModal,
    Daterange,
    QSelect,
  },
  mixins: [formatMoneyMixin, formatDateMixin],
  data: function () {
    return {
      doSearch: "",
      loading: false,
      couponIdParent: null,
      showNewCouponModal: false,
      showModal: false,
      depositCheckId: null,
      coupons: [],
      funds: [],
      startDate: null,
      endDate: null,
      branchoffice_id: null,
      fund_id: null,
      totalAmount: 0,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: this.getCoupons,
        serverSide: false,
        searching: true,
        autoWidth: false,
      },
      fields: {
        created_at: {
          label: "Emisión",
          searchable: true,
          render: (data) => moment(data, 'DD-MM-YYYY').format('DD/MM/YYYY'),
        },
        id: { visible: false },
        "client.name": {
          label: "Cliente",
          searchable: true,
          defaultContent: "Ninguno",
          render: (data, type) =>
            type === 'display' ? `<span class="data-table__primary">${data || 'Ninguno'}</span>` : data,
        },
        number: { label: "Número", searchable: true },
        date_due: {
          label: "Cobro",
          searchable: true,
          render: (data) => moment(data, 'DD-MM-YYYY').format('DD/MM/YYYY'),
        },
        origen: { label: "Orígen", searchable: true },
        amount: {
          label: "Monto",
          align: "right",
          render: this.formatoDinamicoMoneda,
        },
        status: { label: "Estado", searchable: true },
        actions: {
          isLocal: true,
          label: "Acciones",
          width: "120px",
          align: "right",
          render: (_data, _type, row) => {
            if (!row.action) return '';
            return `
              <div class="table-action-group">
                <button data-action="edit" class="table-action-btn" type="button" title="Editar">
                  <i class="bi bi-pencil"></i>
                </button>
                <button data-action="cash" class="table-action-btn" type="button" title="Cobrar / Depositar">
                  <i class="bi bi-bank"></i>
                </button>
                <button data-action="delete" class="table-action-btn" type="button" title="Borrar">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            `;
          },
        },
      },
    };
  },
  watch: {
    doSearch(newValue, oldValue) {
      if (newValue.length >= 4 || oldValue.length >= 4) {
        this.$refs.table.search(this.doSearch);
      }
      if (newValue === "" && oldValue.length > 0) {
        this.$refs.table.search(this.doSearch);
      }
    },
    filters() {
      this.refreshTable();
    },
  },
  computed: {
    ...mapState('branchoffices', ['branchoffices']),
    branchofficeOptions() {
      return this.branchoffices.map(b => ({ value: b.id, label: b.name }));
    },
    daterange() {
      if (this.startDate === null || this.endDate === null) {
        return null;
      }
      const startDate = this.formatoFecha2Daterange(this.startDate);
      const endDate = this.formatoFecha2Daterange(this.endDate);
      return `${startDate} - ${endDate}`;
    },
    filters() {
      return {
        branchoffice_id: this.branchoffice_id,
        fund_id: this.fund_id,
        daterange: this.daterange,
      };
    },
  },
  methods: {
    depositForm(fundId) {
      this.showModal = false;
      this.loading = true;
      const depositData = {
        fund_id: fundId,
        coupon_id: this.depositCheckId,
      };
      this.$http.post("/api/funds/coupons/deposit", depositData).then((response) => {
        this.loading = false;
        if (response.data.code == 201) {
          this.refreshTable();
        }
      });
    },
    deleteCoupon(data) {
      if (!confirm("¿Está seguro que desea borrar este cupón?")) return;
      this.$http.post("/api/funds/coupons/delete", { id: data.id }).then((response) => {
        if (response.data.code == 201) {
          this.refreshTable();
        }
      });
    },
    changeCouponId(data) {
      this.couponIdParent = data.id;
      this.showNewCouponModal = true;
    },
    openNewcoupon() {
      this.couponIdParent = null;
      this.showNewCouponModal = true;
    },
    closeNewCoupon() {
      this.showNewCouponModal = false;
      this.couponIdParent = null;
    },
    onCouponSaved() {
      this.closeNewCoupon();
      this.refreshTable();
    },
    showcashCouponModal(data) {
      this.depositCheckId = data.id;
      this.showModal = true;
    },
    getFunds() {
      this.$http.get("/api/funds/listSimple").then((response) => {
        this.funds = response.data.data;
      });
    },
    getCoupons(d, cb) {
      this.$http
        .get("/api/funds/coupons/list", { params: this.filters })
        .then((response) => {
          this.coupons = response.data.data;
          cb(response.data);
        });
    },
    getTotalAmount() {
      this.$http.get(process.env.VUE_APP_BASE_URL + '/api/funds/coupons/totalAmount').then((response) => {
        this.totalAmount = response.data.data;
      });
    },
    refreshTable() {
      if (this.$refs.table !== undefined) this.$refs.table.reload();
      this.getTotalAmount();
    },
    setDefaultDateRange() {
      const today = new Date();
      this.startDate = this.formatDate(today);
      this.endDate = this.formatDate(today);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${day}/${month}/${year}`;
    },
    dateCreated(date) {
      this.startDate = date.startDate;
      this.endDate = date.endDate;
    },
    exportCSV() {
      this.$http.post(process.env.VUE_APP_BASE_URL + "/api/reports/CSVCouponsReport", this.filters);
    },
    exportPDF() {
      this.$http.post(process.env.VUE_APP_BASE_URL + "/api/reports/PDFCouponsReport", this.filters);
    },
  },
  mounted() {
    this.setDefaultDateRange();
    this.$store.dispatch('branchoffices/getAllBranchoffices');
    this.getFunds();
    this.getTotalAmount();
    this.$nextTick(() => {
      const dt = this.$refs.table && this.$refs.table.dataTable;
      if (!dt) return;
      dt.on('preXhr.dt', () => { this.loading = true; });
      dt.on('xhr.dt', () => { this.loading = false; });
    });
  },
};
</script>

<style scoped>
.filters-panel__field--inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filters-panel__field--inline .control-label {
  margin: 0;
  white-space: nowrap;
  font-size: 13px;
  color: var(--text);
}

.filters-panel__field--inline > .form-group {
  flex: 1 1 auto;
  margin-bottom: 0;
}

.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 24px;
  overflow-y: auto;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 560px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
  background: var(--surface);
}

.modal-body {
  max-height: 80vh;
  overflow-y: auto;
  padding: 0;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
